import {Chip, IconButton, styled} from '@mui/material'
import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos'
import EditIcon from '@mui/icons-material/Edit'
import SaveIcon from '@mui/icons-material/Save'

import {useI18n} from 'store/Store'
import {Colors, Texts} from 'appearance'
import Button from 'components/Control/Button'
import {useNavigate} from 'react-router-dom'
import {useDeviceDetect} from 'services/hooks'
import analyticsService from 'services/analytic'

const ClientHeader = ({
    client,
    editMode,
    toggleEdit,
    submit,
    showEditButton,
}) => {
    const {i18n} = useI18n()
    const navigate = useNavigate()
    const {isMobile} = useDeviceDetect()

    return (
        <Container>
            <FormTopRightSide>
                <IconButton
                    style={{alignSelf: 'start'}}
                    onClick={() => {
                        navigate('/clients')
                        analyticsService.existingClientPressed('back')
                    }}>
                    <ArrowForwardIosIcon />
                </IconButton>

                <ClientDetails>
                    <ClientNameContainer>
                        <ClientName>
                            {`${client.ClientFirstName || ''} ${
                                client.ClientLastName || ''
                            }`}
                        </ClientName>
                        {client.Priority && (
                            <PriorityChip label={client.Priority} />
                        )}
                    </ClientNameContainer>

                    <StatusContainer>
                        <Texts.BoldText>
                            {i18n.t('clients.ClientStatus')}:
                        </Texts.BoldText>
                        <Texts.RegularText>
                            {client.ClientStatus}
                        </Texts.RegularText>
                    </StatusContainer>
                </ClientDetails>
            </FormTopRightSide>
            {showEditButton && (
                <FormTopLeftSide isMobile={isMobile}>
                    {editMode ? (
                        <>
                            <CancelButton
                                variant="contained"
                                onClick={toggleEdit}>
                                {i18n.t('form.cancel')}
                            </CancelButton>
                            <SaveButton
                                onClick={submit}
                                startIcon={<SaveIcon />}
                                variant="contained"
                                color="secondary">
                                {i18n.t('form.save')}
                            </SaveButton>
                        </>
                    ) : (
                        <EditButton
                            size="small"
                            disableRipple
                            onClick={toggleEdit}
                            startIcon={<EditIcon />}>
                            {i18n.t('form.edit')}
                        </EditButton>
                    )}
                </FormTopLeftSide>
            )}
        </Container>
    )
}

export default ClientHeader

const Container = styled('div')`
    display: flex;
    width: 100%;
    justify-content: space-between;
    padding-inline-end: 120px;
    padding: 24px;
    padding-top: 48px;
    flex-wrap: wrap;
    background: ${Colors.LIGHT_BLUE};
`

const FormTopRightSide = styled('div')`
    display: flex;
    gap: 24px;
`

const ClientDetails = styled('div')`
    display: flex;
    flex-direction: column;
    padding: 3px;
    gap: 24px;
`

const ClientNameContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 24px;
`

const ClientName = styled(Texts.BoldText)`
    font-size: 35px;
    line-height: 0;
`
const PriorityChip = styled(Chip)`
    border-radius: 5px;
    height: 25px;
    padding: 3px;
    margin-top: 4px;
    background: ${Colors.PRIORITY_CHIP};
`
const StatusContainer = styled('div')`
    display: flex;
    align-items: center;
    gap: 4px;
`
const FormTopLeftSide = styled('div')`
    display: flex;
    align-items: center;
    gap: 8px;
    margin-top: ${({isMobile}) => (isMobile ? 10 : 0)}px; ;
`

const SaveButton = styled(Button)`
    width: 120px;
    display: flex;
    justify-content: space-around;
    padding: 10px;
    align-items: center;
    line-height: 0;
    & .MuiButton-startIcon {
        margin: 0;
        font-size: inherit;
    }
`

const CancelButton = styled(Button)`
    background: ${Colors.CANCEL_BUTTON_BACKGROUND};
    color: ${Colors.PRIMARY_TEXT};
    width: 120px;
    &:hover {
        background: ${Colors.CANCEL_BUTTON_BACKGROUND};
    }
`

const EditButton = styled(Button)`
    color: ${Colors.PRIMARY_TEXT};
    font-size: 16px;
`
